export function calculateTotalPrice(pieces) {
  return pieces.reduce((acc, piece) => {
    const price = parseFloat(piece.price_of_piece.replace('R$ ', '').replace(/\./g, '').replace(',', '.').trim());
    const quantity = parseInt(piece.quantity_of_piece, 10);

    const total = acc + (price * quantity);
    return total;
  }, 0);
}

export function formatPrice(price) {
  return price.toFixed(2).replace('.', ',')
}